import React from 'react';
import useStyles from 'components/Footer/style';

const Footer = () => {
  const classes = useStyles();
  const copyRight = `© ТОО «Личная касса». 2005-${new Date().getFullYear()}`;

  return (
    <footer className={classes.footer}>
      <div className={classes.footCont}>{copyRight}</div>
    </footer>
  );
};

export default Footer;
